import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { ApplicationState } from '@feature/store/application-store';
import * as filterActions from '@common/filter/actions/filter.actions';
import { DashboardItem } from '@dashboards/models/dashboard-item';
import { ITable } from '@common/models/table';
import { IColumnDefinition } from '@common/models/column-definition';
import { DataFormatter } from '@common/services/data-formatter.service';
import { RuleSet, Rule } from 'ngx-angular-query-builder';

@Injectable()
export class FilterService {

  constructor(
      private readonly store: Store<ApplicationState>,
      private readonly dataFormatter: DataFormatter
  ) {
  }

  loadFilters(widget: DashboardItem) {
    this.store.dispatch(new filterActions.LoadWidgetFilter(new filterActions.WidgetFilterActionPayload(widget.id)));
    }

  getRuleValue(rule: Rule): string {
    if (rule.operator.toLowerCase() === 'between') {
      if (this.isDate(rule.value.field1.toString())) {
        return `${this.dataFormatter.formatDate(rule.value.field1)} and
                ${this.dataFormatter.formatDate(rule.value.field2)}`;
      } else {
        return `${rule.value.field1} and ${rule.value.field2}`;
      }
    } else if (this.isDate(rule.value.toString())) {
      return this.dataFormatter.formatDate(rule.value);
    }
    return rule.value;
  }

  isDate(value: string): boolean {
    return isNaN(+value) && !isNaN(Date.parse(value));
    }

  getFilterString(filter: RuleSet, filteredPrefix: string, showingAllText: string): string {
    if (filter && filter.rules && filter.rules.length > 0) {
      let resultString: string = '';
      filter.rules.forEach(x => {
        if (!(x as RuleSet).rules) {
          const rule = x as Rule;
          let condition: string = '';
          if (resultString.length > 0) {
            condition = `${filter.condition} `;
          } else {
              resultString = `${filteredPrefix} `;
          }
          let operatorString = rule.operator;
          if (rule.operator === 'equal') {
            operatorString = 'is';
          }
            const fieldName = rule.field.replace('System', '');
            const item: string = `${condition}${fieldName} ${operatorString} ${this.getRuleValue(rule)}`;
          resultString = resultString + ' ' + item;
        }
      });

      return resultString;
    }
      return showingAllText;
  }

  getFilterStrings(filter: RuleSet) : string[] {
    if (filter?.rules?.length > 0) {
      const result: string[] = [];
      filter.rules.forEach(x => {
        if (!(x as RuleSet).rules) {
          const rule = x as Rule;
          let condition = '';
          if (result.length > 0) {
            condition = `${filter.condition} `;
          }
          result.push(`${condition}${rule.field} ${rule.operator} ${rule.value}`);
        }
      });
      return result;
    }
    return undefined;
  }
}
